module.exports = __webpack_public_path__ + "img/lebanon.a540b458.svg";